import * as React from 'react';

export default ({bodyText, bodySubText, benefitList, bodyHeader}: ValuePropTextProps) => {
   return (
      <div className="modal-message">
         {(bodyText || bodySubText || bodyHeader) &&
            <div className="body-text-container">
               {bodyHeader && <span className="body-text body-header">{bodyHeader}</span>}
               {bodyText && <span className="body-text">{bodyText}</span>}
               {bodySubText && <span className="body-sub-text">{bodySubText}</span>}
            </div>
         }
         {benefitList.length > 0 &&
         <div className="checked-listing">
            <ul>
               {benefitList.map((listText, index) => <li key={index}>{listText}</li>)}
            </ul>
         </div>
         }
      </div>
   );
};

export interface ValuePropTextProps {
   bodyText?: string | JSX.Element;
   bodySubText?: string | JSX.Element;
   bodyHeader?: string;
   benefitList: string[];
}